import { DatePickerProps } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import JapaneseHolidays from 'japanese-holidays';
import { CellRenderInfo } from 'rc-picker/lib/interface';

const cellRender: DatePickerProps['cellRender'] = (current: Dayjs, info: CellRenderInfo<Dayjs>) => {
  if (info.type !== 'date' || !dayjs.isDayjs(current)) {
    return info.originNode;
  }

  // Japan holiday
  if (JapaneseHolidays.isHoliday(new Date(current.valueOf()))) {
    return <div className='ant-picker-cell-inner bg-[#FFCCCC]'>{current.date()}</div>;
  }
  // Weekend
  if ([0, 6].includes(current.day())) {
    return <div className='ant-picker-cell-inner bg-[#CCCCCC]'>{current.date()}</div>;
  }

  return info.originNode;
};

export { cellRender };
